<template>
  <b-modal
    id="check-proof-transfer"
    hide-footer
    hide-header
    dialog-class="p-0"
    body-class="p-0"
    centered
  >
    <img
      :src="url"
      alt=""
    >
  </b-modal>
</template>

<script>
export default {
  name: 'ModalCheckProofTransfer',
  props: {
    url: {
      type: String,
      required: true,
    },
  },
}
</script>
<style scoped>

.p-0 {
padding: 0 !important;
}

</style>
